import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ExcursionIconNew } from "../../../../helper/HwIcon";
import useBodyScrollLock from "../../../../hooks/useBodyScrollLock";

const STEPS = ["Searching tours & activities", "Comparing prices", "Applying best deals"];

export const ExcursionSearchLoader = ({ city = "", date = "" }) => {
  const [pct, setPct] = useState(0);

  useBodyScrollLock();

  useEffect(() => {
    const t = setInterval(() => {
      setPct((p) => {
        if (p >= 90) return 90;
        const np = p + 0.8 * (p > 80 ? 0.3 : 1);
        return np >= 90 ? 90 : np;
      });
    }, 60);
    return () => clearInterval(t);
  }, []);

  const p = Math.round(pct);
  const stage = pct < 35 ? 0 : pct < 75 ? 1 : 2;

  return createPortal(
    <div className="esl-overlay">
      <style>{`
        .esl-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:24px;z-index:99999}
        .esl-modal{width:100%;max-width:500px;background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 24px 60px rgba(15,25,55,.24);animation:esl-pop .4s cubic-bezier(.2,.8,.2,1) both}
        .esl-head{background:#F3F7FF;border-bottom:1px solid #E3EAFB;padding:24px 30px 22px;display:flex;flex-direction:column;align-items:center;gap:16px}
        .esl-balloonWrap{height:66px;display:flex;align-items:flex-end;justify-content:center}
        .esl-balloon{animation:esl-float 2.6s ease-in-out infinite;line-height:0}
        .esl-balloon svg{width:58px;height:58px;display:block;color:#2F6BF5}
        .esl-ctx{display:flex;align-items:center;justify-content:center;gap:16px;flex-wrap:wrap}
        .esl-ctxItem{text-align:center}
        .esl-ctxLbl{font-size:12px;font-weight:600;color:#000}
        .esl-ctxVal{font-size:19px;font-weight:800;color:#1B1F2B;letter-spacing:-.01em;line-height:1.15;text-transform:capitalize}
        .esl-ctxSep{width:1px;align-self:stretch;min-height:30px;background:#D9E2F5}
        .esl-body{padding:24px 30px 28px;display:flex;flex-direction:column;gap:20px}
        .esl-title{font-size:18px;font-weight:700;color:#1B1F2B}
        .esl-steps{display:flex;flex-direction:column;gap:12px}
        .esl-step{display:flex;align-items:center;gap:12px;font-size:14px;font-weight:600}
        .esl-ic{width:20px;height:20px;border-radius:50%;box-sizing:border-box;flex:none;display:flex;align-items:center;justify-content:center}
        .esl-ic.done{background:#2F6BF5}
        .esl-ic.spin{border:2px solid #D5E0FB;border-top-color:#2F6BF5;animation:esl-spin .8s linear infinite}
        .esl-ic.pend{border:2px solid #E4E6EB}
        .esl-track{height:6px;border-radius:999px;background:#EEF1F6;overflow:hidden}
        .esl-fill{height:100%;background:#2F6BF5;border-radius:999px;transition:width .2s linear}
        .esl-progrow{display:flex;justify-content:space-between;font-size:12px;font-weight:600;color:#5B6070;margin-top:8px}
        @keyframes esl-pop{from{opacity:0;transform:translateY(16px) scale(.97)}to{opacity:1;transform:none}}
        @keyframes esl-spin{to{transform:rotate(360deg)}}
        @keyframes esl-float{0%,100%{transform:translateY(0)}50%{transform:translateY(-9px)}}
      `}</style>

      <div className="esl-modal">
        <div className="esl-head">
          <div className="esl-balloonWrap">
            <span className="esl-balloon"><ExcursionIconNew /></span>
          </div>
          {(city || date) ? (
            <div className="esl-ctx">
              {city ? (
                <div className="esl-ctxItem">
                  <div className="esl-ctxLbl">Destination</div>
                  <div className="esl-ctxVal">{city}</div>
                </div>
              ) : null}
              {city && date ? <div className="esl-ctxSep" /> : null}
              {date ? (
                <div className="esl-ctxItem">
                  <div className="esl-ctxLbl">Travel date</div>
                  <div className="esl-ctxVal">{date}</div>
                </div>
              ) : null}
            </div>
          ) : null}
        </div>

        <div className="esl-body">
          <div className="esl-title">Hold on, we're finding the best tours for you</div>

          <div className="esl-steps">
            {STEPS.map((label, i) => (
              <div className="esl-step" key={i}>
                {i < stage ? (
                  <span className="esl-ic done"><svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="#fff" strokeWidth="2"><path d="M2 6.5 5 9l5-6" /></svg></span>
                ) : i === stage ? (
                  <span className="esl-ic spin" />
                ) : (
                  <span className="esl-ic pend" />
                )}
                <span style={{ color: i > stage ? "#9AA0AD" : "#1B1F2B" }}>{label}</span>
              </div>
            ))}
          </div>

          <div>
            <div className="esl-track"><div className="esl-fill" style={{ width: p + "%" }} /></div>
            <div className="esl-progrow">
              <span>Exploring top experiences</span>
              <span>{p}%</span>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ExcursionSearchLoader;
